<form
  #form="ngForm"
  novalidate
  class="w-full"
>
  <h1 class="mb-4 justify-self-center text-xl">Fuel ROB</h1>

  <div
    class="w-full justify-self-end"
    data-ping-host
  >
    @for (row of offshoreStockStore.fuelRob().fuelRobRows; track $index) {
      <div class="flex w-full gap-1 space-y-1">
        <nsp-input-label
          [label]="`Fuel type ${$index + 1}`"
          [required]="true"
          class="w-1/3"
        />

        <div class="w-1/2">
          <nsp-select-input
            [id]="`fuelRobRows-fuelType-${$index}`"
            [name]="`fuelRobRows-fuelType-${$index}`"
            [options]="filterAvailableFuelTypeOptions($index)"
            [required]="true"
            [showClear]="true"
            [value]="row.fuelType.value"
            [ngModel]="row.fuelType.value"
            placeholder="Select fuel type"
          />
        </div>
        <div class="w-1/2">
          <nsp-number-input
            [id]="`fuelRobRows-quantity-${$index}`"
            [name]="`fuelRobRows-quantity-${$index}`"
            [required]="true"
            [value]="row.quantity.value"
            [ngModel]="row.quantity.value"
            placeholder="Enter quantity"
            unit="MT"
            class="w-1/2"
          />
        </div>
      </div>
    }
  </div>
</form>
